
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[path]",
      function () {
        return require("private-next-pages/products/[path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[path]"])
      });
    }
  